import { createContext, FC, useContext } from 'react';
import { useStore } from 'zustand';
import {
  AnalyticsFilterStoreInstance,
  getAnalyticsFilterStore,
} from 'pages/ReportsPage/store/analyticsFilter.store';
import {
  AnalyticsFilterStore,
  AnalyticsFilterViewKey,
} from 'pages/ReportsPage/store/analyticsFilter.store.types';

const AnalyticsFilterViewContext = createContext<AnalyticsFilterStoreInstance | null>(null);

export const AnalyticsFilterViewProvider: FC<{ view: AnalyticsFilterViewKey }> = ({
  view,
  children,
}) => (
  <AnalyticsFilterViewContext.Provider value={getAnalyticsFilterStore(view)}>
    {children}
  </AnalyticsFilterViewContext.Provider>
);

export function useAnalyticsFilterStore<T>(selector: (state: AnalyticsFilterStore) => T): T {
  const store = useContext(AnalyticsFilterViewContext);
  if (!store) {
    throw new Error('useAnalyticsFilterStore must be used within an AnalyticsFilterViewProvider');
  }
  return useStore(store, selector);
}
